import TopMasthead from './components/TopMasthead';
import HeroEdition from './components/HeroEdition';
import HeatLadder from './components/HeatLadder';
import FocusFeatures from './components/FocusFeatures';
import DebateLive from './components/DebateLive';
import RisingForecast from './components/RisingForecast';
import BriefTimeline from './components/BriefTimeline';
import SiteFooter from './components/SiteFooter';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-100 text-foreground-900">
      <TopMasthead />
      <main>
        <HeroEdition />
        <HeatLadder />
        <FocusFeatures />
        <DebateLive />
        <RisingForecast />
        <BriefTimeline />
      </main>
      <SiteFooter />
    </div>
  );
}